import { createFileRoute } from "@tanstack/react-router"

import { AuthPage } from "@/components/auth-page.js"

export const Route = createFileRoute("/_auth/signin")({
  component: () => <AuthPage mode="signin" />,
})
